import { render, staticRenderFns } from "./readOnly.vue?vue&type=template&id=0262f56e&"
import script from "./readOnly.vue?vue&type=script&lang=js&"
export * from "./readOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports